export default function KeepRushIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="6" y="12" width="26" height="38" rx="5" fill="#2a9d8f" stroke="#fff" strokeWidth="2.5" transform="rotate(-12 19 31)" />
      <rect x="30" y="10" width="26" height="38" rx="5" fill="#ff8a1f" stroke="#fff" strokeWidth="2.5" transform="rotate(10 43 29)" />
      <path d="M14 22l12 18M26 22L14 40" stroke="#fff" strokeWidth="4" strokeLinecap="round" transform="rotate(-12 19 31)" />
      <path d="M44 18l6 10-6 10-6-10z" fill="#7ff0e0" stroke="#3a2a6a" strokeWidth="2" strokeLinejoin="round" />
      <path d="M22 60l-4-6 4-6h10l4 6-4 6z" fill="#5d566b" stroke="#3a3445" strokeWidth="2" strokeLinejoin="round" />
      <path d="M27 40l4 7-4 7-4-7z" fill="#4b2f8f" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" />
      <circle cx="10" cy="54" r="6" fill="#f5a300" stroke="#8a5200" strokeWidth="2" />
      <text x="10" y="57.5" textAnchor="middle" fontSize="9" fontWeight="900" fill="#4a2a00">4</text>
    </svg>
  );
}
